import { Injectable } from '@angular/core';
import { resetpasswordmodel } from '../../models/user/user.resetPassword.model';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { Ng2DeviceService } from 'ng2-device-detector';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';

declare var Crypto: any;
declare var CryptoService: any;
@Injectable()
export class resetPasswordService {
  CryptoObj: any;
  cryptoService: any;
  constructor(private utilserv: utilityService, private deviceService: Ng2DeviceService, private geoloc: geolocation) {
    this.CryptoObj = Crypto;
    this.cryptoService = new CryptoService();
  }
  resetPassword(userPasswordmodel) {
    return this.utilserv.soapPostwithoutAction(this.getChangePassEnvelope(userPasswordmodel), AppSettings.forgot_pass_soap_url);
  }
  //Method for sending mail for password reset
  getChangePassEnvelope(objPasswordModal) {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                      <s:Header>
                        <a:Action s:mustUnderstand="1">http://ForgotPasswordSoapService/IMicroServiceForgotPassword/ResetPassword</a:Action>
                        <a:MessageID>urn:uuid:acf430eb-bc90-4c85-8f06-99aa8317af76</a:MessageID>
                        <a:ReplyTo>
                          <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                        </a:ReplyTo>
                      </s:Header>
                      <s:Body>
                        <ResetPasswordRequest xmlns="http://ForgotPasswordSoapService/">
                          <DOB></DOB>
                          <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                            <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                            <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                            <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                            <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                            <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                            <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                            <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                            <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                            <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                            <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                            <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                          </DeviceDetails>
                          <KeyUID>${objPasswordModal.KeyUID ? objPasswordModal.KeyUID : ''}</KeyUID>
                          <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                          <OTP>${objPasswordModal.OTP ? objPasswordModal.OTP : ''}</OTP>
                          <Password>${objPasswordModal.Password ? this.cryptoService.RSAEncrypt(objPasswordModal.Password, sessionStorage.publicKeyRSA) : ''}</Password>
                          <TansactionID>${objPasswordModal.TansactionID ? objPasswordModal.TansactionID : ''}</TansactionID>
                          <UserID>${objPasswordModal.UserID ? objPasswordModal.UserID : ''}</UserID>
                        </ResetPasswordRequest>
                      </s:Body>
                      </s:Envelope>`;
    return envelope;
  }

  resetPasswordEditProfile(objPasswordModal: resetpasswordmodel) {
    return this.utilserv.soapPostwithoutAction(this.getresetPassEdituserEnvelope(objPasswordModal), AppSettings.forgot_pass_soap_url);
  }

  // Reset Password edit profile
  getresetPassEdituserEnvelope(objPasswordModal: resetpasswordmodel) {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
        <s:Header>
          <a:Action s:mustUnderstand="1">http://ForgotPasswordSoapService/IMicroServiceForgotPassword/ChangePassword</a:Action>
          <a:MessageID>urn:uuid:73d6bb70-dcf8-40e9-8e94-e1162026c589</a:MessageID>
          <a:ReplyTo>
            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
          </a:ReplyTo>
      </s:Header>
        <s:Body>
          <ChangePasswordRequest xmlns="http://ForgotPasswordSoapService/">
          <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
            <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
            <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
            <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
            <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
            <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
            <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
            <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
            <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
            <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
            <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
          </DeviceDetails>
          <KeyUID>${sessionStorage.KeyUID}</KeyUID>
             <LanguageCode>${sessionStorage.langCode}</LanguageCode>
            <NewPassword>${objPasswordModal.NewPassWord}</NewPassword>
            <OldPassword>${objPasswordModal.OldPassWord}</OldPassword>
            <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common.MicroService"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
            </SessionObject>
          </ChangePasswordRequest>
        </s:Body>
      </s:Envelope>`;
    return envelope;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/user.resetchangepassword.service.ts